<div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header">
          <p class="card-title h4 float-left">{{ title }}</p>
          <button
            type="button"
            class="close float-right"
            aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="card-body">
          <form
            action=""
            [formGroup]="pagoForm"
            (ngSubmit)="registerPago(pagoForm.value)"
            class="form-horizontal form-material"
            id="pagoform"
            novalidate
          >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="pagoForm.controls['nro_comprobante']"
                [controlName]="'nro_comprobante'"
              >
                <label for="nro_comprobante">Nro de Comprobante</label>
                <input
                  class="form-control"
                  type="text"
                  id="nro_comprobante"
                  formControlName="nro_comprobante"
                  placeholder="nro_comprobante"
                />
              </app-form-error-wrapper>
            </div>
          </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="pagoForm.controls['fecha']"
                  [controlName]="'fecha'"
                >
                  <label for="fecha">Fecha de pago</label>
                  <input
                    class="form-control"
                    type="date"
                    id="time"
                    formControlName="fecha"
                    placeholder="fecha"
                  />
                  
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="pagoForm.controls['monto']"
                  [controlName]="'monto'"
                >
                  <label for="monto">monto</label>
                  <input
                    class="form-control"
                    type="text"
                    id="monto"
                    formControlName="monto"
                    placeholder="monto"
                  />
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                  [control]="pagoForm.controls['detalle']"
                  [controlName]="'detalle'"
                >
                  <label for="Detalle">Detalle</label>
                  <input
                    class="form-control"
                    type="text"
                    id="detalle"
                    formControlName="detalle"
                    placeholder="Detalle"
                  />
                </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group m-t-20">
              <div class="col-xs-12">
                <app-form-error-wrapper
                [control]="pagoForm.controls['proveedor_id']"
                [controlName]="'proveedor_id'"
              >
                <label for="Cliente">Proveedor</label>
                 <ng-select
                  bindLabel="nombres"
                  placeholder="Selecionar Proveedor"
                  [searchable]="true"
                  formControlName="proveedor_id"
                >
                  <ng-option>
                    Seleccionar todos
                  </ng-option>
                  <ng-option [value]="item" *ngFor="let item of proveedores">
                    {{ item.nombre }} 
                  </ng-option>
                </ng-select> 
              </app-form-error-wrapper>
              </div>
            </div>
            <div class="form-group text-center m-t-20">
              <div class="col-xs-12">
                <button
                  class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                  [disabled]="pagoForm.invalid || isLoading"
                >
                  <app-button-loader
                    [isLoading]="isLoading"
                    [label]="'Agregar'"
                  ></app-button-loader>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
